import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { resetAccount } from '@/api/login';
import { toLogin } from '@/utils/login';
export default {
  name: 'LogoutDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dialogVisible: this.showDialog
    };
  },
  methods: {
    // 同步模板数据
    updateTemplateData: function updateTemplateData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$resetAccount, status, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return resetAccount();

              case 2:
                _yield$resetAccount = _context.sent;
                status = _yield$resetAccount.status;
                data = _yield$resetAccount.data;

                if (!(status !== 1)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                _this.$message({
                  type: 'success',
                  message: data.msg
                });

                _this.handleClose(); // 3秒后退出登陆


                setTimeout(function () {
                  localStorage.removeItem('outline_cache');
                  localStorage.removeItem('subject');
                  localStorage.removeItem('preciousMessage');
                  localStorage.removeItem('preciousInformation');
                  toLogin();
                }, 3000);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleClose: function handleClose() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$emit('update:showDialog', false);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};